import script from "./AbsenceDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceDetailsDialog.vue?vue&type=style&index=0&id=3256f3d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3256f3d8"]])

export default __exports__